module.exports = __webpack_public_path__ + "2d0de0f055b367374ffe430006358e7e.svg";